
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getPaymentMethod, setPayeePayment } from '@/api/order/globalPay'
import { paymentCountry, paymentCurrency } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import { Form as ElForm } from 'element-ui'


@Component({
  name: 'globalPayments',
  components: {}
})
export default class extends Vue {
  get language() {
    return AppModule.language
  }
  private infoFrom: any = {
    payment_type: '2', // 账户类型
    country_code: null, // 国家类型
    currency: null, // 货币类型
    payment_method: null, // 支付方式
    swift_fee_type: null, //SWIFT 的手续费类型
    upstream_amount: null, // 到账金额
    address: null, //收款人地址

    proxy_bank_name: null,
    first_name: null,
    last_name: null,
    account_no: null,
    swift_code: null,
    bank_branch_code: null,
    bank_address: null,
    proxy_bank_address: null,
    proxy_bank_swift: null
  }
  // private beneficiary: any = {}
  private countryCode: any = ''
  private countryList = paymentCountry
  private currencyList = paymentCurrency

  private changeType() {
    this.infoFrom.country_code = null
    this.infoFrom.currency = null
    this.showSwift = false // 重置付款方式
    this.showLocal = false
    this.swift = false
    this.local = false
  }

  private changeArea() {
    this.infoFrom.currency = null
  }

  private parameterArr: any = {}
  private localMethod: any[] = []
  private swiftMethod: any[] = []

  public swift: boolean = false
  public local: boolean = false

  public showSwift: boolean = false
  public showLocal: boolean = false

  private async changeCurrency() {
    this.showSwift = false // 重置付款方式
    this.showLocal = false
    this.swift = false
    this.local = false
    try {
      let data: any = {
        payment_type: this.infoFrom.payment_type,
        country_code: this.infoFrom.country_code,
        currency: this.infoFrom.currency
      }
      await getPaymentMethod(data).then((res: any) => {
        this.parameterArr = res
        if (res.LOCAL && res.SWIFT) {
          this.showSwift = true
          this.showLocal = true
          // this.localMethod = res.LOCAL
          // this.swiftMethod = res.SWIFT
        } else if (res.LOCAL) {
          this.showLocal = true
        } else if (res.SWIFT) {
          this.showSwift = true
        }
      })
    } catch (e) {}
  }

  private swiftChange() {
    // 重置付款方式
    this.local = false
    this.infoFrom.payment_method = 'SWIFT'
    if (this.swift) {
      this.swiftMethod = this.parameterArr.SWIFT
      this.infoFrom.bank_name = null
      this.infoFrom.first_name = null
      this.infoFrom.last_name = null
      this.infoFrom.account_no = null
      this.infoFrom.bank_branch_code = null
    }
  }

  private localChange() {
    // 重置付款方式
    this.swift = false
    this.infoFrom.payment_method = 'LOCAL'
    if (this.local) {
      this.localMethod = this.parameterArr.LOCAL
      this.infoFrom.swift_fee_type = null
      this.infoFrom.first_name = null
      this.infoFrom.last_name = null
      this.infoFrom.account_no = null
      this.infoFrom.swift_code = null
      this.infoFrom.bank_branch_code = null
      this.infoFrom.bank_address = null
      this.infoFrom.proxy_bank_name = null
      this.infoFrom.proxy_bank_address = null
      this.infoFrom.proxy_bank_swift = null
    }
  }

  private save() {
    ;(this.$refs.infoFrom as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          const data: any = {
            ...this.infoFrom
          }
          delObjEmptyKey(data)
          await setPayeePayment(data).then(() => {
            this.$message({
              message: 'Operation successful!',
              type: 'success'
            })
            this.infoFrom.country_code = null
            this.infoFrom.currency = null
            this.infoFrom.payment_method = null
            this.showSwift = false
            this.showLocal = false
            this.swift = false
            this.local = false
          })
        } catch (e) {}
      }
    })
  }

  mounted() {}
}
